import type { UUID } from '@/types/Id'

interface OrganizationUsersQueryKeyArgs {
  orgId: UUID | ''
}

interface OrganizationFilesQueryKeyArgs {
  orgId: UUID | ''
}

interface OrganizationFilesIndexStatusQueryKeyArgs {
  orgId: UUID | ''
}

interface OrganizationFilesEntityExtractionStatusQueryKeyArgs {
  orgId: UUID | ''
}

interface OrganizationQueryKeyArgs {
  orgId: UUID | ''
}

interface PursuitSettingsQueryKeyArgs {
  orgId: UUID | ''
}

export const organizationFilesQueryKeys = {
  all: () => ['organization-files'] as const,
  organization: (keyArgs: OrganizationFilesQueryKeyArgs) =>
    ['organization-files', keyArgs.orgId] as const,
  count: (keyArgs: OrganizationFilesQueryKeyArgs) =>
    ['organization-files', keyArgs.orgId, 'count'] as const,
}

export const organizationFilesIndexStatusQueryKeys = {
  all: () => ['organization-files-index-status'] as const,
  live: (keyArgs: OrganizationFilesIndexStatusQueryKeyArgs) =>
    ['organization-files-index-status', 'live', keyArgs.orgId] as const,
  pollBoost: (keyArgs: OrganizationFilesIndexStatusQueryKeyArgs) =>
    ['organization-files-index-status', 'poll-boost', keyArgs.orgId] as const,
}

export const organizationFilesEntityExtractionStatusQueryKeys = {
  all: () => ['organization-files-entity-extraction-status'] as const,
  live: (keyArgs: OrganizationFilesEntityExtractionStatusQueryKeyArgs) =>
    [
      'organization-files-entity-extraction-status',
      'live',
      keyArgs.orgId,
    ] as const,
}

export const organizationUsersQueryKeys = {
  all: () => ['organization-users'] as const,
  organization: (keyArgs: OrganizationUsersQueryKeyArgs) =>
    ['organization-users', keyArgs.orgId] as const,
}

export const organizationsQueryKeys = {
  all: () => ['organizations'] as const,
  admin: () => ['organizations', 'admin'] as const,
  default: () => ['organizations', 'default'] as const,
  organization: (keyArgs: OrganizationQueryKeyArgs) =>
    ['organizations', keyArgs.orgId] as const,
}

export const pursuitSettingsQueryKeys = {
  all: () => ['pursuit-settings'] as const,
  organization: (keyArgs: PursuitSettingsQueryKeyArgs) =>
    ['pursuit-settings', keyArgs.orgId] as const,
}

interface OrganizationSavedCodeMutationKeyArgs {
  orgId: UUID | ''
}

export const organizationSavedCodeMutationKeys = {
  all: () => ['organization-saved-code'] as const,
  organization: (keyArgs: OrganizationSavedCodeMutationKeyArgs) =>
    ['organization-saved-code', keyArgs.orgId] as const,
}
